import { QuickSwitch, QuickSwitchItem } from '../insight/config.insight.model';
import { BaseState, defaultBaseState } from '../insight/insight.state';

import { SuperGroupExtra } from './super-group.hi.model';

export const storeStateMapper = (state: any): RootState => ({
    ...state.humanInsight,
    ...state.insight,
    // activeView: state.humanInsight.activePath,
    // activePath: state.humanInsight.activeView
});

export interface SuperGroupState {
    pending: boolean;
    quickSwitch?: QuickSwitch<SuperGroupExtra>;
    filteredItems?: Array<QuickSwitchItem<SuperGroupExtra>>;
    active?: QuickSwitchItem<SuperGroupExtra>;
}

export interface RootState extends BaseState {
    superGroup: SuperGroupState;
}

export const defaultState = (): RootState => ({
    ...defaultBaseState(),
    superGroup: {
        pending: false,
    },
});
